module.exports = __webpack_public_path__ + "static/media/bicamsinlogo.940a1f81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/participants/bicamsinlogo.jpg
// module id = 25
// module chunks = 0